import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CRUDRootHeaderButton } from './CRUDRootHeaderButton';
import { CRUDRootTableView } from './CRUDRootTableView';

export const CRUDRootTable = ({ model, createAction = "create", updateAction = "edit", updateBlockAction = "block", btnText = `Create new ${model.item}` }) => {

    const { headers, getData, deleteRequest, title, forbidCreateNew } = model;
    const history = useNavigate();

    const updateLinkUrl = (root, systemId) => `/${root}/${updateAction}/${systemId}`;

    const updateBlockLinkUrl = (root, systemId) => `/${root}/${updateBlockAction}/${systemId}`;

    const [table, updateTableData] = CRUDRootTableView(getData, deleteRequest, updateLinkUrl, updateBlockLinkUrl, headers, model);

    const createPage = () => console.log("TODO: Add select page");

    return (
        <div className="backend__articles">
            <CRUDRootHeaderButton title={title} btnText={btnText} btnOnClick={() => createPage()} />
            {table}
        </div>
    )
};